/**
 * @file This plugin checks if a user has a non-existent lang preference stored and resets them back to "en" if they do.
 * This is important since we're removing 4 previously supported langs and don't want users to be stuck.
 */

export default defineNuxtPlugin({
  parallel: true,
  async setup() {
    if (import.meta.env.TEST) return

    const { $i18n } = useNuxtApp()
    if (!$i18n || !$i18n.locale?.value) return

    const { isCurrentLocaleSupported, setCurrentLanguage } = useLanguage()
    if (isCurrentLocaleSupported()) return

    const DEFAULT_LANG = 'en-US'
    await setCurrentLanguage(DEFAULT_LANG)
  },
})
